"use strict";

function ServiceResponseRepository(storage) {
	function update(serviceName, response) {
		// var lastResponse = serviceResponses[serviceName] || {} ;
		var serviceResponses = storage.getItem('service-response') || {} ; 
		serviceResponses[serviceName] = response;
		storage.setItem('service-response', serviceResponses) ;
	}

	function getLastResponseFrom(serviceName) {
		var serviceResponses = storage.getItem('service-response') ;
		return serviceResponses[serviceName] || null;
	}

	return {
		update: update,
		getLastResponseFrom: getLastResponseFrom
	};
}
